import { XMarkIcon } from "@heroicons/react/24/outline"
import {
  Dialog,
  DialogBackdrop,
  DialogPanel,
  DialogTitle,
} from "@headlessui/react"
import { ReactNode } from "react"
import clsx from "clsx"

type ModalProps = {
  children: ReactNode
  show: boolean
  onClose: () => void
  maxWidthClassName?: string
  hideHeader?: boolean
} & (
  | { hideHeader: true; title?: string }
  | { hideHeader?: false; title: string }
)

const Modal = ({
  title,
  children,
  show,
  onClose,
  maxWidthClassName = "sm:max-w-lg",
  hideHeader = false,
}: ModalProps) => (
  <Dialog as="div" className="relative z-50" onClose={onClose} open={show}>
    <DialogBackdrop
      transition
      className="fixed inset-0 bg-black/60 transition-opacity data-closed:opacity-0 data-enter:duration-300 data-enter:ease-out data-leave:duration-200 data-leave:ease-in"
    />

    <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
      <div className="pb-safe-offset-4 flex min-h-full items-end justify-center px-4 pt-4 text-center sm:items-center sm:p-0">
        <DialogPanel
          transition
          className={clsx(
            "relative w-full transform overflow-hidden rounded-2xl bg-gray-50 px-4 pt-5 pb-4 text-left shadow-xl transition-all sm:my-8 sm:p-6",
            "data-closed:translate-y-4 data-closed:opacity-0 data-closed:sm:translate-y-0 data-closed:sm:scale-95",
            "data-enter:duration-300 data-enter:ease-out",
            "data-leave:duration-200 data-leave:ease-in",
            maxWidthClassName
          )}
        >
          {!hideHeader && (
            <div className="flex items-center justify-between border-b border-gray-200 pb-3">
              <DialogTitle className="text-lg font-semibold tracking-tight text-gray-900">
                {title}
              </DialogTitle>
              <button
                type="button"
                className="focus:ring-chessdrop-500 rounded-md text-gray-500 hover:text-gray-600 focus:ring-2 focus:ring-offset-2 focus:outline-none"
                onClick={onClose}
              >
                <span className="sr-only">Close</span>
                <XMarkIcon className="h-6 w-6" aria-hidden="true" />
              </button>
            </div>
          )}

          {children}
        </DialogPanel>
      </div>
    </div>
  </Dialog>
)

export default Modal
